import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchPositions(ctx, queryParams) {
        return new Promise((resolve, reject) => {
          axiosIns.get('/position/list', {params:queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
        })
    },
    fetchPosition(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns.get(`/position/${id}`)
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    addPosition(ctx, data) {
        return new Promise((resolve, reject) => {
            axiosIns.post('/position', data)
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    },
    deletePosition(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.delete('/position', {params:data})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    }
    

  },
}
